import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns"
import Navbar from "../Navbar/Navbar";
import "./NewHire.css";
import { FaPlus, FaMinus, FaEdit, FaCheckCircle } from "react-icons/fa";
import {
  addDocumentDetails,
  addEducationDetails,
  addExperinceDetails,
  addFamilyDetails,
  addPersonalDetails,
  downloadOfferFile,
  getDesignation,
  getDocumentList,
  getEducationDetails,
  getExperienceDetails,
  getFamilyDetails,
  getPersonalDetails,
  getUserByLoginId,
  getUserDocumentDetails,
  removeDocument,
} from "../../Redux/NewHire/Action";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import { FaDownload } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import { FaFilePdf } from "react-icons/fa6";
import { EMP_USER_DETAILS } from "../../Redux/NewHire/ActionType";
import { UseGeneratePDF } from "../Employee/UseGeneratePDF";
import { fetchClientDetails } from "../../Redux/Config/Action";


const NewHireDetails = () => {
  const location = useLocation();
  const { rowData } = location.state || {};
  const userId = rowData?.loginId;
  const [ifscError, setIfscError] = useState("");
  const token = localStorage.getItem("token");
  const {
    personalDetails,
    familyListDetails,
    educationListDetails,
    experienceListDetails,
    documentLists,
    userdocslist,
    desiglist,
    empUserDetails,
  } = useSelector((store) => store.newHireData);
  const { clientDetails } = useSelector((store) => store.config);
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const { generatePDF } = UseGeneratePDF();
  const [userdesignation, setUserdesignation] = useState("");
  const [generatePdfFlag, setGeneratePdfFlag] = useState(false);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    dispatch(getPersonalDetails(userId, token));
    dispatch(getFamilyDetails(userId, token));
    dispatch(getEducationDetails(userId, token));
    dispatch(getExperienceDetails(userId, token));
    dispatch(getUserDocumentDetails(userId, token));
    dispatch(getDesignation(token));
  }, [dispatch, userId, token]);


  // Personal Deatils Start
  const [showPersonalModal, setShowPersonalModal] = useState(false);
  const handlePersonalModalClose = () => {
    setShowPersonalModal(false);
  };
  const [formData, setFormData] = useState({
    personalDetailsId: "",
    userId: userId,
    firstName: rowData?.firstName || "",
    lastName: rowData?.lastName || "",
    dateOfBirth: formatDateForInput(rowData?.dob) || "",
    personalEmail: rowData?.personalEmail || "",
    pan: rowData?.pan || "",
    gender: "",
    bloodGroup: "",
    maritalStatus: "",
    mobileNumber: "",
    currentAddress: "",
    permanetAddress: "",
    aadhaar: "",
    esic: "",
    uan: "",
    bankName: "",
    bankAccount: "",
    ifsc: "",
    branch: "",
    actionType: "INSERT",
  });

  useEffect(() => {
    if (personalDetails && Object.keys(personalDetails).length > 0) {
      setIsEdit(true);
      setFormData({
        firstName: rowData?.firstName || "",
        lastName: rowData?.lastName || "",
        dateOfBirth: formatDateForInput(rowData?.dob) || "",
        personalEmail: rowData?.personalEmail || "",
        pan: rowData?.pan || "",
        gender: personalDetails?.gender || "",
        bloodGroup: personalDetails?.bloodGroup || "",
        maritalStatus: personalDetails?.maritalStatus || "",
        mobileNumber: personalDetails?.mobileNumber || "",
        aadhaar: personalDetails?.aadhaar || "",
        esic: personalDetails?.esic || "",
        uan: personalDetails?.uan || "",
        bankName: personalDetails?.bankName || "",
        bankAccount: personalDetails?.bankAccount || "",
        ifsc: personalDetails?.ifsc || "",
        branch: personalDetails?.branch || "",
        currentAddress: personalDetails?.currentAddress || "",
        permanetAddress: personalDetails?.permanetAddress || "",
        personalDetailsId: personalDetails?.personalDetailsId || "",
        actionType: "UPDATE",
      });
    } else {
      setIsEdit(false);
      setFormData({
        personalDetailsId: "",
        userId: userId,
        firstName: rowData?.firstName || "",
        lastName: rowData?.lastName || "",
        dateOfBirth: formatDateForInput(rowData?.dob) || "",
        personalEmail: rowData?.personalEmail || "",
        pan: rowData?.pan || "",
        gender: "",
        bloodGroup: "",
        maritalStatus: "",
        mobileNumber: "",
        currentAddress: "",
        permanetAddress: "",
        aadhaar: "",
        esic: "",
        uan: "",
        bankName: "",
        bankAccount: "",
        ifsc: "",
        branch: "",
        actionType: "INSERT",
      });
    }
  }, [rowData, personalDetails]);

  const handlePersonalInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleDateChange = (date, name) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: date ? format(date, "yyyy-MM-dd") : "",

    }));
  };

  // const handlePersonalValidChange = (e) => {
  //   const { id, value } = e.target;
  //   // Prevent whitespace at the beginning
  //   if (value && /^[\s]/.test(value)) {
  //     e.preventDefault();
  //     return;
  //   }
  //   // Validate name to only allow alphabets
  //   if (id === "bankName" && /[^a-zA-Z\s]/.test(value)) {
  //     e.preventDefault();
  //     return;
  //   }
  //   handlePersonalInputChange(e);
  // };

  const [errors, setErrors] = useState({});

  // const validateForm = () => {
  //   const newErrors = {};

  //   if (formData.mobileNumber && formData.mobileNumber.length !== 10) {
  //     newErrors.mobileNumber = "Mobile number must be exactly 10 digits.";
  //   }

  //   if (formData.aadhaar && formData.aadhaar.length !== 12) {
  //     newErrors.aadhaar = "Aadhaar number must be exactly 12 digits.";
  //   }

  //   setErrors(newErrors);

  //   return Object.keys(newErrors).length === 0;
  // };

  const handlePersonalValidChange = (e) => {
    const { id, value } = e.target;

    // Prevent whitespace at the beginning
    if (value && /^[\s]/.test(value)) {
      e.preventDefault();
      return;
    }

    // Validate name to only allow alphabets
    if (id === "bankName" && /[^a-zA-Z\s]/.test(value)) {
      e.preventDefault();
      return;
    }

    // Validate mobile number (10 digits, positive value only)
    // if (id === "mobileNumber") {
    //   if (!/^\d{0,10}$/.test(value)) {
    //     e.preventDefault();
    //     return;
    //   }
    // }

    // Validate Aadhaar number (12 digits, positive value only)
    // if (id === "aadhaar") {
    //   if (!/^\d{0,12}$/.test(value)) {
    //     e.preventDefault();
    //     return;
    //   }
    // }

    if (["esic", "uan", "bankAccount"].includes(id)) {
      if (value < 0) {
        e.preventDefault();
        return;
      }
    }
    // if (id === "ifsc") {
    //   if (value < 0) {
    //     e.preventDefault();
    //     return;
    //   } else {
    //     const { id, value } = e.target;
    //     let newValue = value.toUpperCase();
    //     const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    //     if (newValue && !ifscRegex.test(newValue)) {
    //       setIfscError ("Invalid IFSC code. Format: 4 letters, 0, 6 alphanumeric.");
    //     }else{
    //       setIfscError("");
    //     }

    //   }
    // }

    handlePersonalInputChange(e);
  };

  const validateAndSetIFSC = (value) => {
    let error = "";

    // IFSC format: 4 letters + 0 + 6 alphanumeric
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    if (value && !ifscRegex.test(value)) {
      error = "Invalid IFSC code. Format: 4 letters, 0, and 6 alphanumeric characters.";
    }

    setFormData({ ...formData, ifsc: value });
    setIfscError(error);
  };


  const handlePersonalSubmit = (e) => {
    e.preventDefault();
    // mobile numberexactly 10 digits or msg
    // if (formData.mobileNumber.length !== 10) {
    //   Swal.fire({
    //     title: "Error!",
    //     text: "Mobile number must be exactly 10 digits.",
    //     icon: "error",
    //     confirmButtonText: "OK",
    //   });
    //   return;
    // }

    //  adhar exactly 12 digits or msg
    // if (formData.aadhaar.length !== 12) {
    //   Swal.fire({
    //     title: "Error!",
    //     text: "Aadhaar number must be exactly 12 digits.",
    //     icon: "error",
    //     confirmButtonText: "OK",
    //   });
    //   return;
    // }

    // if (!validateForm()) {
    //   return;
    // }
    if (!ifscError && (formData.actionType === "INSERT" || formData.actionType === "UPDATE")) {
      const actionMessage =
        formData.actionType === "INSERT" ? "added" : "updated";
      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, submit it!",
        cancelButtonText: "No, cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(addPersonalDetails(formData, token))
            .then(({ success, error }) => {
              if (success) {
                dispatch(getPersonalDetails(userId, token));
                handlePersonalModalClose();
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  text: `Personal information ${actionMessage} successfully!`,
                  timer: 2000,
                  showConfirmButton: false,
                });
              } else {
                Swal.fire({
                  title: "Error!",
                  text:
                    error ||
                    "There was an error submitting the personal details.",
                  icon: "error",
                  confirmButtonText: "OK",
                });
              }
            })
            .catch(() => {
              Swal.fire({
                title: "Error!",
                text: "There was an error submitting the personal details.",
                icon: "error",
                confirmButtonText: "OK",
              });
            });
        }
      });
    }
  };

  //Family details start

  const [showFamilyModal, setShowFamilyModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedFamilyIndex, setSelectedFamilyIndex] = useState(null);
  const [familyDetails, setFamilyDetails] = useState([
    {
      familyDetailsId: "",
      userId: userId,
      relationship: "",
      name: "",
      dob: "",
      occupation: "",
    },
  ]);

  const relationshipOptions = [
    { value: "Father", name: "" },
    { value: "Mother", name: "" },
    { value: "Brother", name: "" },
    { value: "Sister", name: "" },
    { value: "Son", name: "" },
    { value: "Daughter", name: "" },
    { value: "Spouse", name: "" },
  ];

  const handleEditFamilyDetail = (index) => {
    const selectedFamilyMember = familyListDetails[index];
    const updatedFamilyDetails = {
      ...selectedFamilyMember,
      userId: userId,
    };
    setSelectedFamilyIndex(index);
    setEditMode(true);
    setFamilyDetails([updatedFamilyDetails]);
    setShowFamilyModal(true);
  };

  const handleFamilyChange = (e, index) => {
    const { name, value } = e.target;
    const updatedFamilyDetails = [...familyDetails];
    updatedFamilyDetails[index][name] = value;
    setFamilyDetails(updatedFamilyDetails);
  };

  const handleFamilyDateChange = (date, fieldName, index) => {
    const updatedFamilyDetails = [...familyDetails];
    updatedFamilyDetails[index][fieldName] = date
      ? format(date, "yyyy-MM-dd")
      : "";
    setFamilyDetails(updatedFamilyDetails);
  };


  const addFamilyDetail = () => {
    setFamilyDetails([
      ...familyDetails,
      {
        familyDetailsId: "",
        userId: userId,
        relationship: "",
        name: "",
        dob: "",
        occupation: "",
      },
    ]);
  };

  const removeFamilyDetail = (index) => {
    const updatedFamilyDetails = familyDetails.filter((_, i) => i !== index);
    setFamilyDetails(updatedFamilyDetails);
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    // Prevent whitespace at the beginning
    if (value && /^[\s]/.test(value)) {
      e.preventDefault();
      return;
    }
    // Validate name to only allow alphabets
    if (
      (name === "name" || name === "occupation") &&
      /[^a-zA-Z\s]/.test(value)
    ) {
      e.preventDefault();
      return;
    }
    handleFamilyChange(e, index);
  };

  const clearInputFields = () => {
    setFamilyDetails([
      {
        familyDetailsId: "",
        userId: userId,
        relationship: "",
        name: "",
        dob: "",
        occupation: "",
      },
    ]);
  };

  const handleFamilyModalClose = () => {
    clearInputFields();
    setShowFamilyModal(false);
  };

  const handleFamilySubmit = (e) => {
    e.preventDefault();
    const hasMissingDob = familyDetails.some(member => !member.dob);
    if (hasMissingDob) {
      alert("Date Of Birth is required for family members");
      return;
    }
    const actionType = editMode ? "UPDATE" : "INSERT";
    const actionMessage = editMode ? "updated" : "added";
    const familyDetailsData = {
      actionType,
      familyDetailsList: familyDetails,
    };
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(addFamilyDetails(familyDetailsData, token))
          .then(({ success, error }) => {
            if (success) {
              clearInputFields();
              setShowFamilyModal(false);
              dispatch(getFamilyDetails(userId, token));

              const familyDetailsAccordion =
                document.getElementById("flush-collapseOne");
              const familyDetailsButton = document.querySelector(
                '[aria-controls="flush-collapseOne"]'
              );
              if (!familyDetailsAccordion.classList.contains("show")) {
                familyDetailsAccordion.classList.add("show");
                familyDetailsButton.setAttribute("aria-expanded", "true");
              }
              Swal.fire({
                icon: "success",
                title: "Success",
                text: `Family details ${actionMessage} successfully!`,
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text:
                  error || "There was an error submitting the family details.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error submitting the family details.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    });
  };
  // Family details end

  // Educational details start
  const [showEducationModal, setShowEducationModal] = useState(false);
  const [editEducation, setEditEducation] = useState(false);
  const [selectedEducationIndex, setSelectedEducationIndex] = useState(null);
  const [educationFields, setEducationFields] = useState([
    {
      educationDetailsId: "",
      userId: userId,
      qualification: "",
      university: "",
      college: "",
      specialization: "",
      yop: "",
      percentage: "",
    },
  ]);

  const handleEducationChange = (e, index) => {
    const { name, value } = e.target;
    const updatedEducationFields = [...educationFields];
    const currentYear = new Date().getFullYear();

    if (name === "yop") {
      if (parseInt(value, 10) > currentYear) {
        Swal.fire({
          icon: "error",
          title: "Invalid Year",
          text: `Year of Passing cannot exceed the current year (${currentYear}).`,
        });
        updatedEducationFields[index][name] = currentYear;
      } else {
        updatedEducationFields[index][name] = value;
      }
    }
    if (value < 0) {
      Swal.fire({
        icon: "error",
        title: "Invalid Input",
        text: `${name === "yop" ? "Year of Passing" : "Percentage"
          } cannot be negative.`,
      });
      return;
    }
    if (name === "percentage") {
      if (parseInt(value, 10) > 100) {
        Swal.fire({
          icon: "error",
          title: "Invalid Percentage",
          text: "Percentage cannot exceed 100.",
        });
        updatedEducationFields[index][name] = 100;
      } else {
        updatedEducationFields[index][name] = value;
      }
    }

    if (name !== "yop" && name !== "percentage") {
      updatedEducationFields[index][name] = value;
    }
    setEducationFields(updatedEducationFields);
  };

  const handleEducationInputChange = (e, index) => {
    const { name, value } = e.target;
    // Prevent whitespace at the beginning
    if (value && /^[\s]/.test(value)) {
      e.preventDefault();
      return;
    }
    if (
      (name === "yop" || name === "percentage") &&
      (parseInt(value, 10) < 0 || value.includes("-"))
    ) {
      e.preventDefault();

      return;
    }
    // Validate name to only allow alphabets
    if (
      (name === "qualification" ||
        name === "university" ||
        name === "college" ||
        name === "specialization") &&
      /[^a-zA-Z\s]/.test(value)
    ) {
      e.preventDefault();
      return;
    }
    handleEducationChange(e, index);
  };

  const handleEditEducationDetail = (index) => {
    const selectedEducationData = educationListDetails[index];
    const updatedEducationDetails = {
      ...selectedEducationData,
      userId: userId,
    };
    setSelectedEducationIndex(index);
    setEditEducation(true);
    setEducationFields([updatedEducationDetails]);
    setShowEducationModal(true);
  };

  const addEducationDetail = () => {
    setEducationFields([
      ...educationFields,
      {
        educationDetailsId: "",
        userId: userId,
        qualification: "",
        university: "",
        college: "",
        specialization: "",
        yop: "",
        percentage: "",
      },
    ]);
  };

  const removeEducationDetail = (index) => {
    const updatedEducationFields = educationFields.filter(
      (_, i) => i !== index
    );
    setEducationFields(updatedEducationFields);
  };

  const clearEducationInputFields = () => {
    setEducationFields([
      {
        educationDetailsId: "",
        userId: userId,
        qualification: "",
        university: "",
        college: "",
        specialization: "",
        yop: "",
        percentage: "",
      },
    ]);
  };

  const handleEducationModalClose = () => {
    clearEducationInputFields();
    setShowEducationModal(false);
  };

  const handleEducationSubmit = (e) => {
    e.preventDefault();
    const actionType = editEducation ? "UPDATE" : "INSERT";
    const actionMessage = editEducation ? "updated" : "added";
    const educationDetailsData = {
      actionType,
      educationDetailsList: educationFields,
    };
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(addEducationDetails(educationDetailsData, token))
          .then(({ success, error }) => {
            if (success) {
              clearEducationInputFields();
              setShowEducationModal(false);
              dispatch(getEducationDetails(userId, token));

              const familyDetailsAccordion =
                document.getElementById("flush-collapseTwo");
              const familyDetailsButton = document.querySelector(
                '[aria-controls="flush-collapseTwo"]'
              );
              if (!familyDetailsAccordion.classList.contains("show")) {
                familyDetailsAccordion.classList.add("show");
                familyDetailsButton.setAttribute("aria-expanded", "true");
              }
              Swal.fire({
                icon: "success",
                title: "Success",
                text: `Education details ${actionMessage} successfully!`,
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text:
                  error ||
                  "There was an error submitting the education details.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error submitting the education details.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  // Experience details start
  const [showExperienceModal, setShowExperienceModal] = useState(false);
  const [editExperience, setEditExperience] = useState(false);
  const [selectedExperienceIndex, setSelectedExperienceIndex] = useState(null);
  const [experienceFields, setExperienceFields] = useState([
    {
      experienceDetailsId: "",
      userId: userId,
      company: "",
      designation: "",
      fromDate: "",
      toDate: "",
      reason: "",
    },
  ]);

  const handleExperienceChange = (e, index) => {
    const { name, value } = e.target;
    const updatedExperienceFields = [...experienceFields];
    updatedExperienceFields[index][name] = value;
    setExperienceFields(updatedExperienceFields);
  };

  const handleExperinceDateChange = (date, fieldName, index) => {
    const updatedExperienceFields = [...experienceFields];
    updatedExperienceFields[index][fieldName] = date
      ? format(date, "yyyy-MM-dd")
      : "";
    setExperienceFields(updatedExperienceFields);
  };

  const addExperienceDetail = () => {
    setExperienceFields([
      ...experienceFields,
      {
        experienceDetailsId: "",
        userId: userId,
        company: "",
        designation: "",
        fromDate: "",
        toDate: "",
        reason: "",
      },
    ]);
  };

  const removeExperienceDetail = (index) => {
    const updatedExperienceFields = experienceFields.filter(
      (_, i) => i !== index
    );
    setExperienceFields(updatedExperienceFields);
  };

  const handleExperienceInputChange = (e, index) => {
    const { name, value } = e.target;
    // Prevent whitespace at the beginning
    if (value && /^[\s]/.test(value)) {
      e.preventDefault();
      return;
    }
    // Validate name to only allow alphabets
    if (
      (name === "company" || name === "designation") &&
      /[^a-zA-Z\s]/.test(value)
    ) {
      e.preventDefault();
      return;
    }
    handleExperienceChange(e, index);
  };

  const clearExperienceInputFields = () => {
    setExperienceFields([
      {
        experienceDetailsId: "",
        userId: userId,
        company: "",
        designation: "",
        fromDate: "",
        toDate: "",
        reason: "",
      },
    ]);
  };

  const handleExperienceModalClose = () => {
    clearExperienceInputFields();
    setShowExperienceModal(false);
  };

  const handleEditExperienceDetail = (index) => {
    const selectedExperienceData = experienceListDetails[index];
    const updatedExperienceDetails = {
      ...selectedExperienceData,
      userId: userId,
    };
    setSelectedExperienceIndex(index);
    setEditExperience(true);
    setExperienceFields([updatedExperienceDetails]);
    setShowExperienceModal(true);
  };

  const handleExperienceSubmit = (e) => {
    e.preventDefault();
    const hasMissingDate = experienceFields.some(member => !member.fromDate || !member.toDate);
    if (hasMissingDate) {
      alert("Both From And To Date is Required");
      return;
    }
    const actionType = editExperience ? "UPDATE" : "INSERT";
    const actionMessage = editExperience ? "updated" : "added";
    const experienceDetailsData = {
      actionType,
      experienceDetailsList: experienceFields,
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(addExperinceDetails(experienceDetailsData, token))
          .then(({ success, error }) => {
            if (success) {
              clearExperienceInputFields();
              setShowExperienceModal(false);
              dispatch(getExperienceDetails(userId, token));

              const familyDetailsAccordion = document.getElementById(
                "flush-collapseThree"
              );
              const familyDetailsButton = document.querySelector(
                '[aria-controls="flush-collapseThree"]'
              );
              if (!familyDetailsAccordion.classList.contains("show")) {
                familyDetailsAccordion.classList.add("show");
                familyDetailsButton.setAttribute("aria-expanded", "true");
              }
              Swal.fire({
                icon: "success",
                title: "Success",
                text: `Experience details ${actionMessage} successfully!`,
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text:
                  error ||
                  "There was an error submitting the experience details.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error submitting the experience details.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    });
  };
  // Experience details end

  // Document details start
  const [showDocumentsModal, setShowDocumentsModal] = useState(false);
  const fileInputRefs = useRef([]);
  useEffect(() => {
    dispatch(getDocumentList(userId, token));
  }, [dispatch, userId, token, showDocumentsModal]);

  const [documents, setDocuments] = useState({
    actionType: "",
    userId: userId,
    userDocumentId: "",
    fileName: "",
    documentName: "",
    file: null,
    documentId: "",
    docType: "",
    documentType: "",
  });

  const handleDocumentChange = (e, index) => {
    const { name, value, type, files } = e.target;
    const updatedDocuments = { ...documents };

    if (type === "file") {
      const file = files[0];
      if (
        file &&
        !["application/pdf", "image/jpeg", "image/png"].includes(file.type)
      ) {
        alert("Only PDF and image files are allowed.");
        return;
      }
      updatedDocuments.file = file;
    } else if (name === "fileName") {
      const selectedDoc = JSON.parse(value); // Parse dropdown value
      updatedDocuments.documentId = selectedDoc.documentId;
      updatedDocuments.docType = selectedDoc.docType;
      updatedDocuments.fileName = selectedDoc.fileName;
    } else {
      updatedDocuments[name] = value;
    }

    setDocuments(updatedDocuments);
  };

  const clearDocumentInputFields = () => {
    setDocuments({
      actionType: "",
      userId: userId,
      userDocumentId: "",
      fileName: "",
      documentName: "",
      file: null,
      documentId: "",
      docType: "",
      documentType: "",
    });
    if (fileInputRefs.current) fileInputRefs.current.value = "";
  };

  const handleDocumentModalClose = () => {
    clearDocumentInputFields();
    setShowDocumentsModal(false);
  };

  const handleDocumentSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (documents.file) {
      formData.append("file", documents.file);
    }
    formData.append("userId", documents.userId);
    formData.append("documentId", documents.documentId);
    formData.append("docType", documents.docType);
    formData.append("fileName", documents.fileName);
    formData.append("documentName", documents.documentName);
    formData.append("actionType", documents.actionType);
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(addDocumentDetails(formData, token))
          .then(({ success, error }) => {
            if (success) {
              clearDocumentInputFields();
              setShowDocumentsModal(false);
              dispatch(getUserDocumentDetails(userId, token));

              const documentDetailsAccordion =
                document.getElementById("flush-collapseFour");
              const documentDetailsButton = document.querySelector(
                '[aria-controls="flush-collapseFour"]'
              );
              if (!documentDetailsAccordion.classList.contains("show")) {
                documentDetailsAccordion.classList.add("show");
                documentDetailsButton.setAttribute("aria-expanded", "true");
              }

              Swal.fire({
                icon: "success",
                title: "Success",
                text: `Document details added successfully!`,
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text:
                  error ||
                  "There was an error submitting the document details.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error submitting the document details.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    });
  };
  const handleDownload = (fileName, loginId) => {
    dispatch(downloadOfferFile(loginId, fileName, token));
  };

  const handleDeleteDocument = (docid) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes,Delete!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeDocument(docid, rowData?.username, token))
          .then(({ success, error }) => {
            if (success) {
              dispatch(getUserDocumentDetails(userId, token));
              const documentDetailsAccordion =
                document.getElementById("flush-collapseFour");
              const documentDetailsButton = document.querySelector(
                '[aria-controls="flush-collapseFour"]'
              );
              if (!documentDetailsAccordion.classList.contains("show")) {
                documentDetailsAccordion.classList.add("show");
                documentDetailsButton.setAttribute("aria-expanded", "true");
              }
              Swal.fire({
                icon: "success",
                title: "Success",
                text: `Document removed successfully!`,
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: error || "There was an error removing the document.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error removing the document.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    });
  };

  const handleViewClick = async () => {
    const designation = desiglist.find(
      (desig) => desig.designationId === rowData.designationId);

    if (designation) setUserdesignation(designation.designationName);
    await Promise.all([
      dispatch(getUserByLoginId(userId, token, EMP_USER_DETAILS)),
      dispatch(getPersonalDetails(userId, token)),
      dispatch(getFamilyDetails(userId, token)),
      dispatch(getEducationDetails(userId, token)),
      dispatch(getExperienceDetails(userId, token)),
      dispatch(getUserDocumentDetails(userId, token)),
      dispatch(fetchClientDetails(token)),
    ]);
    setGeneratePdfFlag(true);
  }

  useEffect(() => {
    if (generatePdfFlag) {
      if (
        empUserDetails &&
        personalDetails &&
        familyListDetails &&
        educationListDetails &&
        experienceListDetails &&
        clientDetails
      ) {
        generatePDF(
          empUserDetails,
          personalDetails,
          familyListDetails,
          educationListDetails,
          experienceListDetails,
          clientDetails,
          userdesignation,
          userdocslist,
        );
        setGeneratePdfFlag(false);
      }
    }
  }, [
    empUserDetails,
    personalDetails,
    familyListDetails,
    educationListDetails,
    experienceListDetails,
    clientDetails,
    generatePdfFlag,
    generatePDF,
  ]);
  const [showPayrollModal, setShowPayrollModal] = useState(false);
  const [payrollDetails, setPayrollDetails] = useState({
    month: "",
    year: "",
    salary: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayrollDetails({
      ...payrollDetails,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowPayrollModal(false);
  };

  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div></div>
          <button
            type="button"
            className="btn btn-secondary me-5 mt-3"
            onClick={() => window.history.back()}
          >
            BACK
          </button>
        </div>
        <div className="container my-4">
          <div className="row">
            <div className="col text-center">
              {personalDetails && Object.keys(personalDetails).length > 0 ? (
                <button
                  className="btn btn-success me-2"
                  onClick={() => setShowPersonalModal(true)}
                >
                  <FaCheckCircle className="me-2 mb-1" />
                  Personal Info
                </button>
              ) : (
                <button
                  className="btn btn-primary me-2"
                  onClick={() => setShowPersonalModal(true)}
                >
                  Personal Info
                </button>
              )}
              <button
                className={familyListDetails && familyListDetails.length > 0 ? "btn btn-success me-2" : "btn btn-info me-2"}
                onClick={() => {
                  setEditMode(false);
                  setShowFamilyModal(true);
                }}
              >
                {familyListDetails && familyListDetails.length > 0 ? <FaCheckCircle className="me-2 mb-1" /> : ""}
                Family Details
              </button>
              <button
                className={educationListDetails && educationListDetails.length > 0 ? "btn btn-success me-2" : "btn btn-warning me-2"}
                onClick={() => {
                  setEditEducation(false);
                  setShowEducationModal(true);
                }}
              >
                {educationListDetails && educationListDetails.length > 0 ? <FaCheckCircle className="me-2 mb-1" /> : ""}
                Education Details
              </button>
              <button
                className={userdocslist && userdocslist.length > 0 ? "btn btn-success me-2" : "btn btn-dark me-2"}
                onClick={() => setShowDocumentsModal(true)}
              >
                {userdocslist && userdocslist.length > 0 ? <FaCheckCircle className="me-2 mb-1" /> : ""}
                Upload Documents
              </button>
              <button
                className={experienceListDetails && experienceListDetails.length > 0 ? "btn btn-success me-2" : "btn btn-secondary me-2"}
                onClick={() => {
                  setEditExperience(false);
                  setShowExperienceModal(true);
                }}
              >
                {experienceListDetails && experienceListDetails.length > 0 ? <FaCheckCircle className="me-2 mb-1" /> : ""}
                Experience Details
              </button>
              {personalDetails && Object.keys(personalDetails).length > 0 && (<button
                className="btn btn-primary"
                onClick={handleViewClick}
              >
                Preview PDF <FaFilePdf />
              </button>
              )}

              {/* <button className="btn btn-secondary" onClick={() => setShowPayrollModal(true)}>Payroll Details</button> */}
            </div>
          </div>
          <br></br>
          {/* Personal Details Table */}
          <div className="card3">
            <div className="card-body">
              <div className="my-3">
                <h4 className="text-center">Personal Details</h4>
                <table className="table table-striped table-bordered table-hover table-responsive compact-table">
                  <tbody>
                    <tr>
                      <td className="tablecell text-white">First Name</td>
                      <td className="bg-light text-dark">
                        {rowData.firstName || "-"}
                      </td>
                      <td className="tablecell text-white">Last Name</td>
                      <td className="bg-light text-dark">
                        {rowData.lastName || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="tablecell text-white">Date of Birth</td>
                      <td className="bg-light text-dark">
                        {rowData.dob ? formatDate(rowData.dob) : "-"}
                      </td>
                      <td className="tablecell text-white">Gender</td>
                      <td className="bg-light text-dark">
                        {personalDetails.gender || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="tablecell text-white">Email</td>
                      <td className="bg-light text-dark">
                        {rowData.personalEmail || "-"}
                      </td>
                      <td className="tablecell text-white">Mobile Number</td>
                      <td className="bg-light text-dark">
                        {personalDetails.mobileNumber || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="tablecell text-white">Blood Group</td>
                      <td className="bg-light text-dark">
                        {personalDetails.bloodGroup || "-"}
                      </td>
                      <td className="tablecell text-white">Marital Status</td>
                      <td className="bg-light text-dark">
                        {personalDetails.maritalStatus || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="tablecell text-white">Current Address</td>
                      <td className="bg-light text-dark">
                        {personalDetails.currentAddress || "-"}
                      </td>
                      <td className="tablecell text-white">Permanent Address</td>
                      <td className="bg-light text-dark">
                        {personalDetails.permanetAddress || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="tablecell text-white">Aadhaar</td>
                      <td className="bg-light text-dark">
                        {personalDetails.aadhaar || "-"}
                      </td>
                      <td className="tablecell text-white">PAN</td>
                      <td className="bg-light text-dark">{rowData.pan || "-"}</td>
                    </tr>
                    <tr>
                      <td className="tablecell text-white">UAN</td>
                      <td className="bg-light text-dark">
                        {personalDetails.uan || "-"}
                      </td>
                      <td className="tablecell text-white">ESI</td>
                      <td className="bg-light text-dark">
                        {personalDetails.esic || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="tablecell text-white">Bank Name</td>
                      <td className="bg-light text-dark">
                        {personalDetails.bankName || "-"}
                      </td>
                      <td className="tablecell text-white">Bank Account</td>
                      <td className="bg-light text-dark">
                        {personalDetails.bankAccount || "-"}
                      </td>
                    </tr>
                    <tr>
                      <td className="tablecell text-white">IFSC</td>
                      <td className="bg-light text-dark">
                        {personalDetails.ifsc || "-"}
                      </td>
                      <td className="tablecell text-white">Branch</td>
                      <td className="bg-light text-dark">
                        {personalDetails.branch || "-"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Accordion for Other Details */}
              <div
                className="accordion accordion-flush custom-accordion"
                id="accordionFlushExample"
              >
                {/* Family Details */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingOne">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                    >
                      <h5>Family Details</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingOne"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      <table className="table table-striped table-bordered table-hover table-responsive">
                        <thead>
                          <tr>
                            <th className="tablecell text-white">SN</th>
                            <th className="tablecell text-white">Relation</th>
                            <th className="tablecell text-white">Name</th>
                            <th className="tablecell text-white">
                              Date of Birth
                            </th>
                            <th className="tablecell text-white">Occupation</th>
                            <th className="tablecell text-white">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {familyListDetails && familyListDetails.length > 0 ? (
                            familyListDetails.map((familyMember, index) => (
                              <tr key={familyMember.familyDetailsId}>
                                <td>{index + 1}</td>
                                <td>{familyMember.relationship || "-"}</td>
                                <td>{familyMember.name || "-"}</td>
                                <td>
                                  {familyMember.dob
                                    ? formatDate(familyMember.dob)
                                    : "-"}
                                </td>
                                <td>{familyMember.occupation || "-"}</td>
                                <td>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-warning"
                                    onClick={() => handleEditFamilyDetail(index)}
                                  >
                                    <FaEdit />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6">No family details available.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Education Details */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                    >
                      <h5>Education Details</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwo"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      <table className="table table-striped table-bordered table-hover table-responsive">
                        <thead>
                          <tr>
                            <th className="tablecell text-white">SN</th>
                            <th className="tablecell text-white">
                              Qualification
                            </th>
                            <th className="tablecell text-white">University</th>
                            <th className="tablecell text-white">College</th>
                            <th className="tablecell text-white">
                              Specialization
                            </th>
                            <th className="tablecell text-white">
                              Year of Passing
                            </th>
                            <th className="tablecell text-white">Percentage</th>
                            <th className="tablecell text-white">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {educationListDetails &&
                            educationListDetails.length > 0 ? (
                            educationListDetails.map((education, index) => (
                              <tr key={education.educationDetailsId}>
                                <td>{index + 1}</td>
                                <td>{education.qualification}</td>
                                <td>{education.university || "-"}</td>
                                <td>{education.college || "-"}</td>
                                <td>{education.specialization || "-"}</td>
                                <td>{education.yop || "-"}</td>
                                <td>{education.percentage || "-"}</td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-warning"
                                    onClick={() =>
                                      handleEditEducationDetail(index)
                                    }
                                  >
                                    <FaEdit />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6">No education details available.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Experience Details */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                    >
                      <h5>Experience Details</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingThree"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      <table className="table table-striped table-bordered table-hover table-responsive">
                        <thead>
                          <tr>
                            <th className="tablecell text-white">SN</th>
                            <th className="tablecell text-white">Company</th>
                            <th className="tablecell text-white">Designation</th>
                            <th className="tablecell text-white">From Date</th>
                            <th className="tablecell text-white">To Date</th>
                            <th className="tablecell text-white">Reason</th>
                            <th className="tablecell text-white">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {experienceListDetails &&
                            experienceListDetails.length > 0 ? (
                            experienceListDetails.map((experience, index) => (
                              <tr key={experience.experienceDetailsId}>
                                <td>{index + 1}</td>
                                <td>{experience.company || "-"}</td>
                                <td>{experience.designation || "-"}</td>
                                <td>
                                  {experience.fromDate
                                    ? formatDate(experience.fromDate)
                                    : "-"}
                                </td>
                                <td>
                                  {experience.toDate
                                    ? formatDate(experience.toDate)
                                    : "-"}
                                </td>
                                <td>{experience.reason || "-"}</td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-warning"
                                    onClick={() =>
                                      handleEditExperienceDetail(index)
                                    }
                                  >
                                    <FaEdit />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6">
                                No experience details available.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Documents */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="flush-headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFour"
                      aria-expanded="false"
                      aria-controls="flush-collapseFour"
                    >
                      <h5>Documents</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="flush-headingFour"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      <table className="table table-striped table-bordered table-hover table-responsive">
                        <thead>
                          <tr>
                            <th className="tablecell text-white">SN</th>
                            <th className="tablecell text-white">
                              Document Type
                            </th>
                            <th className="tablecell text-white">
                              Document Name
                            </th>
                            <th className="tablecell text-white">File Name</th>
                            <th className="tablecell text-white">Preview</th>
                          </tr>
                        </thead>
                        <tbody>
                          {userdocslist && userdocslist.length > 0 ? (
                            userdocslist.map((document, index) => (
                              <tr key={document.userDocumentId}>
                                <td>{index + 1}</td>
                                <td>{document.docType || "-"}</td>
                                <td>{document.fileName || "-"}</td>
                                <td>{document.documentName || "-"}</td>
                                <td>
                                  <button
                                    onClick={() =>
                                      handleDownload(
                                        document.documentName,
                                        userId
                                      )
                                    }
                                    className="no-border-button me-3"
                                  >
                                    <FaDownload className="download-icon" />
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleDeleteDocument(
                                        document.userDocumentId
                                      )
                                    }
                                    className="no-border-button"
                                  >
                                    <FaTrash className="delete-icon" />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6">No documents details available.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Payroll */}
                {/* <div className="accordion-item">
          <h2 className="accordion-header" id="flush-headingFive">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
              <h5>Payroll Details</h5>
            </button>
          </h2>
          <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
            <div className="accordion-body">
              <table className="table table-striped table-bordered table-hover table-responsive">
                <thead>
                  <tr>
                    <th className="tablecell text-white">SN</th>
                    <th className="tablecell text-white">Pay Component</th>
                    <th className="tablecell text-white">Amount</th>
                    <th className="tablecell text-white">From Date</th>
                    <th className="tablecell text-white">To Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Basic Salary</td>
                    <td>$5000</td>
                    <td>01-01-2023</td>
                    <td>31-12-2023</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal for Personal Info */}
      {showPersonalModal && <div className="modal-backdrop fade show"></div>}
      <div
        className={`modal fade newhire-modal ${showPersonalModal ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="personalInfoModalLabel">
                {isEdit ? "Personal Info" : "Personal Info"}
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handlePersonalModalClose}
              ></button>
            </div>
            <div className="modal-body">
              <form id="personalInfoForm" onSubmit={handlePersonalSubmit}>
                <div className="row mb-3">
                  <div className="col-md-3">
                    <label htmlFor="firstName" className="form-label">
                      <b>First Name</b><span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="firstName"
                      placeholder="Enter first name"
                      value={formData.firstName}
                      onChange={handlePersonalInputChange}
                      disabled
                    />
                    <div className="invalid-feedback">
                      Please provide a first name.
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="lastName" className="form-label">
                      <b>Last Name</b> <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="lastName"
                      placeholder="Enter last name"
                      value={formData.lastName}
                      onChange={handlePersonalInputChange}
                      disabled
                    />
                    <div className="invalid-feedback">
                      Please provide a last name.
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="dateOfBirth" className="form-label">
                      <b>Date of Birth</b> <span className="text-danger">*</span>
                    </label>
                    <DatePicker
                      selected={formData.dateOfBirth ? new Date(formData.dateOfBirth) : null}
                      onChange={(date) => handleDateChange(date, "dateOfBirth")}
                      className="form-control"
                      dateFormat="dd-MM-yyyy"
                      placeholderText="Date of Birth"
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                      disabled={true}
                      onKeyDown={(event) => event.preventDefault()}
                      required
                    />
                    <div className="invalid-feedback">
                      Please provide a valid date of birth.
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="gender" className="form-label">
                      <b>Gender</b> <span className="text-danger">*</span>
                    </label>
                    <select
                      id="gender"
                      className="form-select"
                      value={formData.gender}
                      onChange={handlePersonalInputChange}
                      required
                    >
                      <option value="">Select Gender</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                    </select>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-3">
                    <label htmlFor="bloodGroup" className="form-label">
                      <b>Blood Group</b> <span className="text-danger">*</span>
                    </label>
                    <select
                      id="bloodGroup"
                      className="form-select"
                      value={formData.bloodGroup}
                      onChange={handlePersonalInputChange}
                      required
                    >
                      <option value="">Select Blood Group</option>
                      <option value="A+">A+</option>
                      <option value="A-">A-</option>
                      <option value="B+">B+</option>
                      <option value="B-">B-</option>
                      <option value="AB+">AB+</option>
                      <option value="AB-">AB-</option>
                      <option value="O+">O+</option>
                      <option value="O-">O-</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="maritalStatus" className="form-label">
                      <b>Marital Status</b> <span className="text-danger">*</span>
                    </label>
                    <select
                      id="maritalStatus"
                      className="form-select"
                      value={formData.maritalStatus}
                      onChange={handlePersonalInputChange}
                      required
                    >
                      <option value="">Select Marital Status</option>
                      <option value="M">Married</option>
                      <option value="U">UnMarried</option>

                    </select>
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="personalEmail" className="form-label">
                      <b>Email</b> <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="personalEmail"
                      placeholder="Enter email"
                      value={formData.personalEmail}
                      onChange={handlePersonalInputChange}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="mobileNumber" className="form-label">
                      <b>Mobile Number</b> <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="mobileNumber"
                      placeholder="Enter mobile number"
                      value={formData.mobileNumber}
                      onChange={handlePersonalValidChange}
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 10))
                      }
                      min={1000000000}
                      max={9999999999}
                      required
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="currentAddress" className="form-label">
                      <b>Current Address</b> <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="currentAddress"
                      placeholder="Enter Current Address"
                      value={formData.currentAddress}
                      onChange={handlePersonalValidChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="permanetAddress" className="form-label">
                      <b>Permanent Address</b> <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="permanetAddress"
                      placeholder="Enter Permanent Address"
                      value={formData.permanetAddress}
                      onChange={handlePersonalValidChange}
                      required
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-3">
                    <label htmlFor="bankName" className="form-label">
                      <b>Bank Name</b> <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="bankName"
                      placeholder="Enter bank name"
                      value={formData.bankName}
                      onChange={handlePersonalValidChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="bankAccount" className="form-label">
                      <b>Bank Account Number</b> <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="bankAccount"
                      placeholder="Enter bank account number"
                      value={formData.bankAccount}
                      onChange={handlePersonalValidChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="ifsc" className="form-label">
                      <b>IFSC Code</b> <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="ifsc"
                      placeholder="Enter IFSC code"
                      value={formData.ifsc || ""}
                      onChange={(e) => {
                        const cleanedValue = e.target.value
                          .toUpperCase()
                          .replace(/[^A-Z0-9]/g, "")
                          .slice(0, 11);
                        validateAndSetIFSC(cleanedValue);
                      }}
                      required
                    />
                    {ifscError && <div className="text-danger">{ifscError}</div>}


                  </div>
                  <div className="col-md-3">
                    <label htmlFor="branch" className="form-label">
                      <b>Branch</b><span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="branch"
                      placeholder="Enter branch"
                      value={formData.branch}
                      onChange={handlePersonalValidChange}
                      required
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-3">
                    <label htmlFor="aadhaar" className="form-label">
                      <b>Aadhaar Number</b> <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="aadhaar"
                      placeholder="Enter Aadhaar number"
                      value={formData.aadhaar}
                      onChange={handlePersonalValidChange}
                      onInput={(e) =>
                        (e.target.value = e.target.value.slice(0, 12))
                      }
                      min={100000000000}
                      max={999999999999}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="pan" className="form-label">
                      <b>PAN Number</b> <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="pan"
                      placeholder="Enter PAN number"
                      value={formData.pan}
                      onChange={handlePersonalInputChange}
                      disabled
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="uan" className="form-label">
                      <b>UAN Number</b>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="uan"
                      placeholder="Enter UAN number"
                      value={formData.uan}
                      onChange={handlePersonalValidChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="esic" className="form-label">
                      <b>ESI Number</b>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="esic"
                      placeholder="Enter ESI number"
                      value={formData.esic}
                      onChange={handlePersonalValidChange}
                    />
                  </div>
                </div>
              </form>
            </div>
            <hr></hr>
            <div className="row">
              <div className="col text-center mb-3">
                <button
                  type="submit"
                  form="personalInfoForm"
                 className={`btn ${isEdit ? 'btn-warning' : 'btn-success'}`}
                >
                  {isEdit ? "UPDATE" : "SUBMIT"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Family Details */}
      {showFamilyModal && <div className="modal-backdrop fade show"></div>}
      <div
        className={`modal fade newhire-modal ${showFamilyModal ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editMode ? "Edit Family Details" : "Add Family Details"}
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleFamilyModalClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleFamilySubmit}>
                {familyDetails.map((item, index) => (
                  <div key={index} className="mb-3">
                    <div className="row align-items-center">
                      <div className="col-12 col-md-3">
                        <label className="form-label">
                          <b>Relation</b><sapn className="text-danger">*</sapn>
                        </label>
                        <select
                          className="form-control"
                          name="relationship"
                          value={item.relationship}
                          onChange={(e) => handleFamilyChange(e, index)}
                          required
                        >
                          <option value="">Select relationship</option>
                          {relationshipOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.value}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-12 col-md-3">
                        <label className="form-label">
                          <b>Name</b><sapn className="text-danger">*</sapn>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={item.name}
                          onChange={(e) => handleInputChange(e, index)}
                          placeholder="Enter name"
                          required
                        />
                      </div>
                      <div className="col-12 col-md-2">
                        <label className="form-label">
                          <b>Date of Birth</b><sapn className="text-danger">*</sapn>
                        </label>
                        <DatePicker
                          selected={item.dob ? new Date(item.dob) : null}
                          onChange={(date) => handleFamilyDateChange(date, "dob", index)}
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="Date of Birth"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          maxDate={new Date()}
                          onKeyDown={(event) => event.preventDefault()}
                          required
                        />

                      </div>
                      <div className="col-12 col-md-3">
                        <label className="form-label">
                          <b>Occupation</b><sapn className="text-danger">*</sapn>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="occupation"
                          value={item.occupation}
                          onChange={(e) => handleInputChange(e, index)}
                          placeholder="Enter occupation"
                          required
                        />
                      </div>
                      {!editMode && (
                        <div className="col-12 col-md-1 text-end removeBtn">
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => removeFamilyDetail(index)}
                            disabled={familyDetails.length === 1}
                          >
                            <FaMinus></FaMinus>
                          </button>
                        </div>
                      )}
                    </div>
                    <hr />
                  </div>
                ))}
                {!editMode && (
                  <button
                    type="button"
                    className="btn btn-secondary mt-2"
                    onClick={addFamilyDetail}
                  >
                    <FaPlus></FaPlus>
                  </button>
                )}
                <div className="row">
                  <div className="col text-center mt-3">
                    <button type="submit" className="btn btn-success">
                      SUBMIT
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Education Details */}
      {showEducationModal && <div className="modal-backdrop fade show"></div>}
      <div
        className={`modal fade newhire-modal ${showEducationModal ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editEducation
                  ? "Edit Education Details"
                  : "Add Education Details"}
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleEducationModalClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleEducationSubmit}>
                {educationFields.map((detail, index) => (
                  <div key={index} className="mb-3">
                    <div className="row align-items-center">
                      <div className="col-12 col-md-4">
                        <label className="form-label">
                          <b>Qualification</b><sapn className="text-danger">*</sapn>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="qualification"
                          value={detail.qualification}
                          onChange={(e) => handleEducationInputChange(e, index)}
                          placeholder="Enter qualification"
                          required
                        />
                      </div>
                      <div className="col-12 col-md-4">
                        <label className="form-label">
                          <b>University</b><sapn className="text-danger">*</sapn>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="university"
                          value={detail.university}
                          onChange={(e) => handleEducationInputChange(e, index)}
                          placeholder="Enter university"
                          required
                        />
                      </div>
                      <div className="col-12 col-md-4">
                        <label className="form-label">
                          <b>College</b><sapn className="text-danger">*</sapn>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="college"
                          value={detail.college}
                          onChange={(e) => handleEducationInputChange(e, index)}
                          placeholder="Enter college"
                          required
                        />
                      </div>
                      <div className="col-12 col-md-4">
                        <label className="form-label">
                          <b>Specialization</b><sapn className="text-danger">*</sapn>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="specialization"
                          value={detail.specialization}
                          onChange={(e) => handleEducationInputChange(e, index)}
                          placeholder="Enter specialization"
                          required
                        />
                      </div>
                      <div className="col-12 col-md-3">
                        <label className="form-label">
                          <b>Year of Passing</b><sapn className="text-danger">*</sapn>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="yop"
                          value={detail.yop}
                          onChange={(e) => handleEducationChange(e, index)}
                          placeholder="Enter year of passing"
                          required
                        />
                      </div>
                      <div className="col-12 col-md-3">
                        <label className="form-label">
                          <b>Percentage</b><sapn className="text-danger">*</sapn>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="percentage"
                          value={detail.percentage}
                          onChange={(e) => handleEducationChange(e, index)}
                          placeholder="Enter percentage"
                          required
                        />
                      </div>
                      {!editEducation && (
                        <div className="col-12 col-md-1 text-end removeBtn">
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => removeEducationDetail(index)}
                            disabled={educationFields.length === 1}
                          >
                            <FaMinus />
                          </button>
                        </div>
                      )}
                    </div>
                    <hr />
                  </div>
                ))}
                {!editEducation && (
                  <button
                    type="button"
                    className="btn btn-secondary mt-3"
                    onClick={addEducationDetail}
                  >
                    <FaPlus />
                  </button>
                )}
                <div className="row">
                  <div className="col text-center mt-3">
                    <button type="submit" className="btn btn-success">
                      SUBMIT
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Experience Details */}
      {showExperienceModal && <div className="modal-backdrop fade show"></div>}
      <div
        className={`modal fade newhire-modal ${showExperienceModal ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editExperience
                  ? "Edit Experience Details"
                  : "Add Experience Details"}
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleExperienceModalClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleExperienceSubmit}>
                {experienceFields.map((detail, index) => (
                  <div key={index} className="mb-3">
                    <div className="row align-items-center">
                      <div className="col-12 col-md-3">
                        <label className="form-label">
                          <b>Company</b>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="company"
                          value={detail.company}
                          onChange={(e) =>
                            handleExperienceInputChange(e, index)
                          }
                          placeholder="Enter company"
                          required
                        />
                      </div>
                      <div className="col-12 col-md-3">
                        <label className="form-label">
                          <b>Designation</b>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="designation"
                          value={detail.designation}
                          onChange={(e) =>
                            handleExperienceInputChange(e, index)
                          }
                          placeholder="Enter designation"
                          required
                        />
                      </div>
                      <div className="col-12 col-md-3">
                        <label className="form-label">
                          <b>From Date</b>
                        </label>
                        <DatePicker
                          selected={detail.fromDate ? new Date(detail.fromDate) : null}
                          onChange={(date) => handleExperinceDateChange(date, "fromDate", index)}
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="From Date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          maxDate={new Date()}
                          onKeyDown={(event) => event.preventDefault()}
                          required
                        />
                      </div>
                      <div className="col-12 col-md-3">
                        <label className="form-label">
                          <b>To Date</b>
                        </label>
                        <DatePicker
                          selected={detail.toDate ? new Date(detail.toDate) : null}
                          onChange={(date) => handleExperinceDateChange(date, "toDate", index)}
                          className="form-control"
                          dateFormat="dd-MM-yyyy"
                          placeholderText="To Date"
                          showYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                          maxDate={new Date()}
                          minDate={experienceFields[index].fromDate}
                          onKeyDown={(event) => event.preventDefault()}
                          required
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label">
                          <b>Reason for Leaving</b>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="reason"
                          value={detail.reason}
                          onChange={(e) =>
                            handleExperienceInputChange(e, index)
                          }
                          placeholder="Enter reason for leaving"
                          required
                        />
                      </div>
                      {!editExperience && (
                        <div className="col-12 col-md-1 text-end removeBtn">
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => removeExperienceDetail(index)}
                            disabled={experienceFields.length === 1}
                          >
                            <FaMinus />
                          </button>
                        </div>
                      )}
                    </div>
                    <hr />
                  </div>
                ))}
                {!editExperience && (
                  <button
                    type="button"
                    className="btn btn-secondary mt-3"
                    onClick={addExperienceDetail}
                  >
                    <FaPlus />
                  </button>
                )}
                <div className="text-center"><span className="text-danger fw-bold">Note :</span> You may skip this section if you do not have any prior work experience.</div>
                <div className="row">
                  <div className="col text-center mt-3">
                    <button type="submit" className="btn btn-success">
                      SUBMIT
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Documents */}
      {showDocumentsModal && <div className="modal-backdrop fade show"></div>}
      <div
        className={`modal fade newhire-modal ${showDocumentsModal ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Upload Document</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleDocumentModalClose}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleDocumentSubmit}>
                <div className="mb-3">
                  <div className="row align-items-center">
                    <div className="col-12 col-md-4">
                      <label className="form-label">
                        <b>Document Type</b> <sapn className="text-danger">*</sapn>
                      </label>
                      <select
                        className="form-select"
                        name="fileName"
                        value={JSON.stringify({
                          documentId: documents.documentId,
                          docType: documents.docType,
                          fileName: documents.fileName,
                        })}
                        onChange={handleDocumentChange}
                        required
                      >
                        <option value="">Select document type</option>
                        {documentLists.map((docType, index) => (
                          <option
                            key={`${docType.documentId}-${index}`}
                            value={JSON.stringify({
                              documentId: docType.documentId,
                              docType: docType.docType,
                              fileName: docType.fileName,
                            })}
                          >
                            {docType.fileName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label">
                        <b>Document Name</b> <sapn className="text-danger">*</sapn>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="documentName"
                        value={documents.documentName}
                        onChange={handleDocumentChange}
                        placeholder="Enter document name"
                        required
                      />
                    </div>
                    <div className="col-12 col-md-3">
                      <label className="form-label">
                        <b>File</b> <sapn className="text-danger">*</sapn>
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        name="file"
                        ref={fileInputRefs}
                        onChange={handleDocumentChange}
                        accept=".pdf, image/jpeg, image/png"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col text-center mt-3">
                    <p className="text-muted">
                      <small>
                        <i>
                          <span className="text-danger">*</span> It is mandatory to upload your Bank details, Aadhaar card, and Photograph.
                        </i>
                      </small>
                    </p>

                    <button type="submit" className="btn btn-success">
                      SUBMIT
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Payroll Details */}
      {showPayrollModal && <div className="modal-backdrop fade show"></div>}
      <div
        className={`modal fade newhire-modal ${showPayrollModal ? "show d-block" : ""}`}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Payroll Details</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setShowPayrollModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Month</label>
                  <input
                    type="text"
                    className="form-control"
                    name="month"
                    value={payrollDetails.month}
                    onChange={handleChange}
                    placeholder="Enter month"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Year</label>
                  <input
                    type="text"
                    className="form-control"
                    name="year"
                    value={payrollDetails.year}
                    onChange={handleChange}
                    placeholder="Enter year"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Salary</label>
                  <input
                    type="text"
                    className="form-control"
                    name="salary"
                    value={payrollDetails.salary}
                    onChange={handleChange}
                    placeholder="Enter salary"
                    required
                  />
                </div>
                <div className="text-center mt-3">
                  <button type="submit" className="btn btn-success">
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowPayrollModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewHireDetails;
